module.exports = __webpack_public_path__ + "static/logo-pam-a-casa-7961949f20373412852cbecc3beec32c.png";